/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

import { ILdsStaplesMessageData } from './lds-staples-message.data';
import { ILdsStaplesMessageProps } from './lds-staples-message.props.autogenerated';

export interface ILdsStaplesMessageViewProps extends ILdsStaplesMessageProps<ILdsStaplesMessageData> {}

/**
 *
 * LdsStaplesMessage component
 * @extends {React.PureComponent<ILdsStaplesMessageProps<ILdsStaplesMessageData>>}
 */
class LdsStaplesMessage extends React.PureComponent<ILdsStaplesMessageProps<ILdsStaplesMessageData>> {
    public render(): JSX.Element | null {
        return this.props.renderView(this.props);
    }
}

export default LdsStaplesMessage;
